<template>
  <div class="preview-file">
    <div class="preview-file-imgs">
      <img v-lazy="img" v-for="img in imgs" :key="img" />
    </div>
  </div>
</template>

<script>
import { generatePreviewImgs } from '@/utils/previewFile';
export default {
  name: 'PreviewFile',
  data() {
    return {
      imgs: [],
    };
  },

  async created() {
    let data = await this.$http.get(
      `/backend-api/app/v2/chapterDatum/${this.$route.query.datum_id}`,
    );
    this.imgs = generatePreviewImgs(data);
  },
};
</script>

<style lang="scss" scoped>
.preview-file-imgs {
  width: 90%;
  margin: 0 auto;
  min-height: 100vh;
  text-align: center;
  img {
    width: 100%;
    vertical-align: middle;
  }
}
</style>
